<template>
  <div>
    <vue-good-table
      :columns="columns"
      :rows="brands"
      styleClass="vgt-table"
      :search-options="{
        enabled: true,
      }"
      :pagination-options="{
        enabled: true,
        mode: 'pages',
      }"
    >
      <template #table-row="props">
        <span v-if="props.column.field == 'action'">
          <a
            href="javascript:;"
            class="text-success font-weight-bold text-xs mx-2"
            data-toggle="tooltip"
            data-original-title="Edit user"
            @click="openModalEdit(props.row.id)"
            >Edit</a
          >
          <a
            href="javascript:;"
            class="text-danger font-weight-bold text-xs"
            data-toggle="tooltip"
            data-original-title="Edit user"
            @click="deleteBrand(props.row.id)"
            >Hapus</a
          >
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import { VueGoodTable } from "vue-good-table-next";
import "vue-good-table-next/dist/vue-good-table-next.css";

export default {
  props: ["brands"],
  name: "good-table-brands",
  components: {
    VueGoodTable,
  },
  data() {
    return {
      columns: [
        {
          label: "Nama Brand",
          field: "name",
        },
        {
          label: "Jumlah Produk",
          field: "products_count",
        },
        {
          label: "Opsi",
          field: "action",
          tdClass: "w-px-1",
          thClass: "w-px-1",
        },
      ],
      authToken:
        "Bearer " + JSON.parse(localStorage.getItem("user")).accessToken,
      errors: null,
    };
  },
  methods: {
    openModalEdit(id) {
      this.$parent.openModalEdit(id);
    },
    deleteBrand(id) {
      this.$parent.deleteBrand(id);
    },
  },
};
</script>
